<template>
  <div>
    <div v-if="!isLoading">
      <section class="checker">
        <div id="start-servey" ref="fv-container" class="fv-container">
          <div class="fv-title_outer">
            <p class="fv-title_en">
              Mindful Checker
            </p>
            <p class="fv-title_jp">
              マインドフルチェッカー
            </p>
          </div>
          <div class="fv-contents_outer">
            <div class="fv-img">
              <img src="assets/img/mindful_checker/checker_img.png" alt="">
            </div>
            <div class="fv-contents_box">
              <div class="fv-contents_text_container">
                <p class="fv-content_text">
                  {{ questions.length }}問の質問に回答するだけで今の自分の
                </p>
                <div class="fv-content_points">
                  <div class="fv-content_point-item">
                    <div class="point-icon">
                      <img src="assets/img/mindful_checker/list-icon.png" alt="">
                    </div>
                    <p class="fv-content_text">
                      ストレス値
                    </p>
                  </div>
                  <div class="fv-content_point-item">
                    <div class="point-icon">
                      <img src="assets/img/mindful_checker/list-icon.png" alt="">
                    </div>
                    <p class="fv-content_text">
                      おすすめクラス
                    </p>
                  </div>
                </div>
                <p class="fv-content_text">
                  がわかるストレスチェック機能です。
                </p>
              </div>
              <a href="#" @click.prevent="handleClickNext(-1)">
                <div class="btn_start-answer">
                  <p class="btn-text">
                    早速回答する
                  </p>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div class="servey">
          <div
            v-for="(question, index) of questions"
            :key="question.id"
            class="servey-q"
          >
            <div class="servey-q_number">
              <p class="number_l">
                Q{{ index + 1 }}
              </p>
              <p class="number_s">
                /{{ questions.length }}
              </p>
            </div>
            <div class="servey-q_text survey-required">
              {{ question.question }}
            </div>
            <div v-if="!!errors[index]" class="servey-q_text_error">
              {{ errors[index] }}
            </div>
            <div
              :ref="'question' + index"
              :class="`servey-answer servey-answer_v${
                index % 2 === 0 ? '1' : '2'
              }`"
            >
              <template v-if="question.question_type === 0">
                <div
                  v-for="(answer, answerIndex) of questionAnswers"
                  :key="answer.value"
                  class="answer-block"
                >
                  <div class="icon_a">
                    <img
                      :src="`assets/img/mindful_checker/servey_icon0${
                        question.is_positive ? answerIndex + 1 : 7 - answerIndex
                      }.png`"
                      alt=""
                    >
                  </div>
                  <div
                    :class="
                      `color-scale_a color-scale0${
                        question.is_positive ? answerIndex + 1 : 7 - answerIndex
                      } ` +
                        (answerIndex === 0 ? 'scale_left' : (answerIndex === 6 ? 'scale_right' : ''))
                    "
                  />
                  <p class="answer_subtext">
                    {{ answer }}
                  </p>
                  <input
                    v-model="answers[index]"
                    type="radio"
                    :value="
                      question.is_positive ? answerIndex : 6 - answerIndex
                    "
                    :aria-label="`${
                      question.is_positive ? answerIndex : 6 - answerIndex
                    } ${answer}`"
                    :data-value="
                      question.is_positive ? answerIndex : 6 - answerIndex
                    "
                  >
                </div>
              </template>
              <template v-else>
                <select v-model="answers[index]" class="answer-select">
                  <option :value="undefined" disabled>
                    選択してください
                  </option>
                  <option v-for="option of question.question_options" :key="option.id" :value="option.id">
                    {{ option.option_text }}
                  </option>
                </select>
              </template>
            </div>
            <div :class="['section_btn', index === questions.length - 1 ? 'last' : '']">
              <a
                href="#"
                @click.prevent="handleClickPrev(index)"
              >
                <div class="btn_previous btn_servey">
                  <p class="icon_arrow">
                    <img
                      src="assets/img/mindful_checker/arrow_previous.png"
                      alt=""
                    >
                  </p>
                  <p class="btn-text">前へ</p>
                </div>
              </a>
              <a
                v-if="index !== questions.length - 1"
                href="#"
                @click.prevent="handleClickNext(index)"
              >
                <div class="btn_next btn_servey">
                  <p class="btn-text">次へ</p>
                  <p class="icon_arrow">
                    <img
                      src="assets/img/mindful_checker/arrow_next.png"
                      alt=""
                    >
                  </p>
                </div>
              </a>
              <div
                v-else
                class="btn_next btn_servey last_btn"
                @click.prevent="submitAnswers()"
              >
                <p class="btn-text submit">
                  回答を送信する
                </p>
                <p class="icon_arrow">
                  <img
                    src="assets/img/mindful_checker/arrow_next.png"
                    alt=""
                  >
                </p>
              </div>
            </div>
            <router-link to="/">
              <p class="back_btn">
                マイページTOPへ戻る
              </p>
            </router-link>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import mindfulSurveyService from '@/services/mindfulSurveyService'

export default {
  name: 'MindfulSurvey',
  data() {
    return {
      submiting: false,
      questions: [],
      answers: [],
      isLoading: false,
      questionAnswers: [
        'とてもそう感じる',
        'そう感じる',
        '少しそう感じる',
        'どちらでもない',
        'あまりそう感じない',
        'そう感じない',
        '全くそう感じない'
      ],
      errors: []
    }
  },
  computed: {
    userId() {
      return this.$route.query.uuid
    }
  },
  beforeCreate() {
    document.body.className = 'survey'
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  updated() {
    this.isMobile
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  mounted() {
    this.getQuestions()
  },
  methods: {
    async submitAnswers() {
      try {
        const submitData = this.questions.map((question, index) => {
          if (this.answers[index] === undefined) {
            this.$set(this.errors, index, '回答を選択してください。')
          } else {
            this.$set(this.errors, index, null)
          }
          return {
            question: question.id,
            question_type: question.question_type,
            answer: this.answers[index] ?? null
          }
        })
        const firstErrorIndex = this.errors.findIndex((item) => item !== null)
        if (firstErrorIndex !== -1) {
          this.$refs['question' + firstErrorIndex][0].scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center'
          })
          return
        }

        if (this.submiting) {
          return
        }
        this.submiting = true
        await mindfulSurveyService.submit({
          answers: submitData,
          uid: this.userId
        })
        this.submiting = false

        this.$router.push('/mindful-survey/thanks')
      } catch (error) {
        console.error(error)
      }
    },
    async getQuestions() {
      this.isLoading = true
      const { data } = await mindfulSurveyService.getQuestions()
      if (this.$route.path === '/mindful-survey/company') {
        this.questions = data
      } else {
        this.questions = data.filter(q => q.question_type === 0)
      }
      this.isLoading = false
    },
    handleResize() {
      this.width = window.innerWidth
      this.height = window.innerHeight
      if (this.width <= 767) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    handleClickNext(currentIndex) {
      if (currentIndex > -1) {
        if (this.answers[currentIndex] === undefined) {
          this.$set(this.errors, currentIndex, '回答を選択してください。')
          return
        } else {
          this.$set(this.errors, currentIndex, null)
        }
      }
      this.$refs['question' + (currentIndex + 1)][0].scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
      })
    },
    handleClickPrev(currentIndex) {
      if (currentIndex === 0) {
        this.$refs['fv-container'].scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center'
        })
      } else {
        this.$refs['question' + (currentIndex - 1)][0].scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center'
        })
      }
    }
  }
}
</script>
<style>
@font-face {
  font-family: "Hiragino Kaku Gothic Pro";
  src: url(~@/assets/fonts/HiraKakuProN-W6.woff2);
}
</style>
<style scoped src="@/assets/css/mindful_survey.css">
</style>
